import React from "react";
import "../../../../../Assets/Styles/Toast.scss";

const ErrorToast = (props) => {
  return (
    <div className="error-toast">
      <p> {props.ErrorMessage} </p>
    </div>
  );
};
export default ErrorToast;
